import { render } from "./ExpressDelivery.vue?vue&type=template&id=47ec10ce&scoped=true"
import script from "./ExpressDelivery.vue?vue&type=script&lang=js"
export * from "./ExpressDelivery.vue?vue&type=script&lang=js"

import "./ExpressDelivery.vue?vue&type=style&index=0&id=47ec10ce&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ec10ce"]])

export default __exports__